var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style.loader }, [
    _c("div", { class: _vm.$style.bar }),
    _vm._v(" "),
    _c("div", { class: _vm.$style.bar }),
    _vm._v(" "),
    _c("div", { class: _vm.$style.bar }),
    _vm._v(" "),
    _c("div", { class: _vm.$style.bar })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }